import React, { Fragment, useState, useEffect } from 'react'
import { isValidPhoneNumber } from 'react-phone-number-input'

import authService from '../../../utilities/services/auth.service'

import {
  requestNumberChange,
  updateNumber,
  phoneUnique,
  updateSmsOptIn,
} from '../../../utilities/api'

import SmsOptIn from '../../LoginSignupForm/SmsOptIn'

import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Alert from 'react-bootstrap/Alert'

import { PhoneNumberInput } from '../../PhoneNumberInput'
import { Spinner } from '../../LoadingContainer/Spinner'

export default function LoginSecurityForm({
  user,
  setShow,
  setShowError,
  showError,
  setPhone,
}) {
  const [formValid, setFormValid] = useState(false)

  const [code, setCode] = useState('')

  const [newPhoneNumber] = useState()

  const [phoneNumber, setValue] = useState('')

  const [isValid, setIsValid] = useState(true)
  const [verifying, setVerifying] = useState(false)
  const [updated, setUpdated] = useState(false)

  const [isSaving, setIsSaving] = useState(false)

  const [smsOptIn, setSmsOptIn] = useState(Boolean(user?.smsOptIn))
  const [smsSaving, setSmsSaving] = useState(false)
  const [smsUpdated, setSmsUpdated] = useState(false)
  const [smsError, setSmsError] = useState(false)

  useEffect(() => {
    if (phoneNumber && newPhoneNumber && code) {
      setFormValid(true)
    }
  }, [phoneNumber, newPhoneNumber, code])

  // reset errors when inputs are changed
  useEffect(() => {
    setIsValid(true)
    setShowError(false)
  }, [phoneNumber, code])

  const validNumber = () => {
    return phoneNumber && isValidPhoneNumber(phoneNumber) && isValid
  }

  const handleBlur = () => {
    let data = {
      data: {
        phoneNumber,
      },
    }
    phoneUnique(data)
      .then((res) => {
        if (res.data === 200) {
          setIsValid(true)
        } else {
          setIsValid(false)
        }
      })
      .catch((err) => console.error(err))
  }

  const submitForm = () => {
    setIsSaving(true)
    let phoneNumberData = {
      data: {
        phoneNumber,
      },
    }
    phoneUnique(phoneNumberData).then((res) => {
      if (res.data === 404) {
        setIsSaving(false)
        return
      }
      if (res.data === 200) {
        let data = {
          data: {
            toNumber: phoneNumber,
            fromNumber: user.phoneNumber,
          },
        }
        requestNumberChange(data)
          .then((res) => {
            setIsSaving(false)
            setShow(true)
            setVerifying(true)
          })
          .catch((err) => {
            setIsSaving(false)
            console.error(err)
          })
      }
    })
  }

  const saveSmsOptIn = (next) => {
    const previous = smsOptIn
    setSmsOptIn(next)
    setSmsSaving(true)
    setSmsUpdated(false)
    setSmsError(false)

    updateSmsOptIn({ data: { smsOptIn: next } })
      .then((res) => {
        if (res?.data?.jwt) {
          authService.setUser(res.data)
        }
        setSmsUpdated(true)
      })
      .catch((err) => {
        console.error(err)
        setSmsOptIn(previous)
        setSmsError(true)
      })
      .finally(() => setSmsSaving(false))
  }

  const submitCode = (code) => {
    const length = code.split('').length

    let data = {
      data: {
        code,
      },
    }
    if (length === 6) {
      updateNumber(data)
        .then((res) => {
          setShow(false)
          authService.setUser(res.data)
          setShowError(false)
          setPhone(phoneNumber)
          setUpdated(true)
        })
        .catch((err) => {
          console.error(err)
          setShowError(true)
        })
    }
  }

  return (
    <Fragment>
      {updated && (
        <Alert variant="success" className="mb-3">
          <p>Your phone number has been updated successfully.</p>
        </Alert>
      )}
      <Form className="d-flex-column" id="login-security-form">
        <Form.Group className="form-group" controlId="new-phone-number">
          <Form.Label>New Phone Number</Form.Label>
          <PhoneNumberInput
            phoneNumber={phoneNumber}
            setPhoneNumber={setValue}
            hasError={!isValid}
            onBlur={handleBlur}
            disabled={updated}
            type="phoneAlreadyExists"
          />
        </Form.Group>
        {!updated && (
          <Form.Group className="form-group" controlId="code">
            <Form.Label>Verify Code</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter the 6 digit code"
              required
              name="code"
              maxLength="6"
              className={`${showError ? 'error-border' : ''}`}
              onChange={(e) => {
                setCode(e.target.value)
                submitCode(e.target.value)
              }}
            />
            <Form.Text className="d-block mt-2">
              A 6-digit code should have been sent to you using the new phone
              number specified above.
            </Form.Text>
          </Form.Group>
        )}
        {!verifying && (
          <Button
            disabled={!validNumber() || isSaving}
            className="icon-button"
            size="lg"
            onClick={submitForm}
          >
            {isSaving ? <Spinner /> : 'Update'}
          </Button>
        )}
      </Form>
      <div className="mt-4">
        <h2 className="settings-title mb-2">Text messages</h2>
        {smsUpdated && (
          <Alert variant="success" className="mb-3">
            <p>Your text message preference has been updated.</p>
          </Alert>
        )}
        {smsError && (
          <Alert variant="danger" className="mb-3">
            <p>Your text message preference could not be saved. Try again.</p>
          </Alert>
        )}
        <SmsOptIn
          id="settings-sms-opt-in"
          checked={smsOptIn}
          disabled={smsSaving}
          onChange={saveSmsOptIn}
        />
      </div>
    </Fragment>
  )
}
